const Benefits = () => (
  <>
    <h3 className="font-subtitle3 w-full text-left mb-16">
      Pasos para acceder al beneficio
    </h3>

    <p className="mb-12">
      <span>Paso 1. Ingresa a</span>
      <a href="/hp/" target="_blank" rel="noreferrer">
        www.crehana.com/hp
      </a>
      <span className="ml-8">
        regístrate y haz clic en{' '}
        <span className="tw-font-semibold"> “Registrarte”.</span> Datos
        solicitados para registro o inicio de sesión: e-mail y contraseña.
      </span>
    </p>
    <p className="mb-12">
      Paso 2. Ingresa los datos de compra de tu producto HP y haz clic en
      <span className="tw-font-semibold"> “Continuar”.</span>
      Datos de compra solicitados: número de serie de tu producto HP, nombre
      completo, nombre de tienda/e-commerce, número de teléfono y país en el que
      adquiriste el producto.
    </p>
    <p className="mb-12">
      Paso 3. Busca tus 10 cursos, agregalos al pack y haz clic en{' '}
      <span className="tw-font-semibold"> “Canjea tus cursos”.</span>
    </p>
    <p className="mb-12">
      Paso 4. Confirma el uso de tu cupón dando clic en{' '}
      <span className="tw-font-semibold"> “Confirmar”.</span> Si das clic en
      “Cancelar”, tus cupón no se va a redimir.
    </p>
    <p className="mb-32">Paso 5. Ve a tus cursos y comienza a aprender.</p>
  </>
);

export default Benefits;
